import {
  CancelSubscriptionRenewRequest,
  CancelSubscriptionRenewResponse,
  GetSubscriptionsRequest,
  GetSubscriptionsResponse,
  GetUserSubscriptionsRequest,
  GetUserSubscriptionsResponse, RestoreAppStoreSubscriptionsRequest,
  RestoreAppStoreSubscriptionsResponse,
  RestoreSubscriptionRequest,
  RestoreSubscriptionResponse,
  StartAituWalletPaymentRequest,
  StartAituWalletPaymentResponse,
  SubscriptionContentType,
} from '@btsd/proto-generated-ts/subscription';
import {SubscriptionServiceClient} from '@btsd/proto-generated-ts/subscription.client'
import { GrpcWebTransport } from '@/api/transport.ts';

export class SubscriptionService {
  private client = new SubscriptionServiceClient(GrpcWebTransport);

  public async getSubscriptions({
    nonActive = false,
    available = false,
    countryCode = 398,
    contentType = SubscriptionContentType.NOT_SET,
  }: {
    nonActive?: boolean;
    available?: boolean;
    countryCode?: number;
    contentType?: SubscriptionContentType;
  }): Promise<GetSubscriptionsResponse> {
    const request: GetSubscriptionsRequest = {
      nonActive: nonActive,
      available: available,
      country: countryCode,
      contentType: contentType,
    };

    const {response} = await this.client.getSubscriptions(request);
    return response;
  }

  public async getUserSubscriptions(contentType: SubscriptionContentType = SubscriptionContentType.NOT_SET): Promise<GetUserSubscriptionsResponse> {
    const request: GetUserSubscriptionsRequest = {
      contentType,
    };
    const {response} = await this.client.getUserSubscriptions(request);
    return response;
  }

  public async restoreAppStoreSubscriptions(transactions: string[]): Promise<RestoreAppStoreSubscriptionsResponse> {
    const request: RestoreAppStoreSubscriptionsRequest = {
      jwsTransactions: transactions
    };

    const {response} = await this.client.restoreAppStoreSubscriptions(request);
    return response;
  }

  public async cancelSubscriptionRenew(subscriptionId: string): Promise<CancelSubscriptionRenewResponse> {
    const request: CancelSubscriptionRenewRequest = {
      subscriptionId,
    };

    const {response} = await this.client.cancelSubscriptionRenew(request);
    return response;
  }

    public async startAituWalletPayment(subscriptionId: string, returnUrl: string): Promise<StartAituWalletPaymentResponse> {
        const request: StartAituWalletPaymentRequest = {
            subscriptionId,
            returnUrl
        };

        const {response} = await this.client.startAituWalletPayment(request);
        return response;
    }

    public async restoreSubscription(subscriptionId: string): Promise<RestoreSubscriptionResponse> {
      const request: RestoreSubscriptionRequest = {
        subscriptionId
      }

      const {response} = await this.client.restoreSubscription(request);
      return response;
    }
}

export const subscriptionService = new SubscriptionService();
